// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5993":"71d526b2","6201":"71d526b2"}[chunkId] + ".chunk.css";
};